document.addEventListener('DOMContentLoaded', function () {

    class SubscriptionWidget extends HTMLElement {
      constructor() {
        super();
        this.items = this.querySelectorAll('.subscription-widget--item-header > fieldset input');
        this.frequencies = this.querySelector('.product-form-frequencies select');
        this.onceOffSummary = this.querySelector('.once-off-summary');
        this.subscriptionSummary = this.querySelector('.subscription-summary');

        if(document.querySelector('.pdp-sticky-atc')) {
          this.subStatusContainer = document.querySelector('.pdp-sticky-atc--info-subscription-status');
        }
        
        
        if (this.items) {
          for (const item of this.items) {
            item.addEventListener('change', this.itemChangeHandler.bind(this));
          }
        }

        if (this.frequencies) {
            this.frequencies.addEventListener('change', this.frequencyChangeHandler.bind(this));
        }
      }
      
      itemChangeHandler(e) {
        for (const item of this.items) {
          item.checked = item == e.target;
          let itemParent = item.closest('.subscription-widget--item');
          
          if (itemParent) {
            let isSuscription = e.target.closest('.subscription-widget--item').dataset.issubscription == 'true';

            itemParent.classList.toggle('active', item == e.target);
            if(this.onceOffSummary) this.querySelector('.once-off-summary').classList.toggle('hidden', item != e.target);
            if(this.subscriptionSummary) this.querySelector('.subscription-summary').classList.toggle('hidden', item == e.target);
            
            if (isSuscription) {
              this.querySelector('[name="selling_plan"]:not([value=""])').checked = true;
            } else {
              if(this.onceOffSummary) this.querySelector('.once-off-summary').classList.toggle('hidden', item != e.target);
              if(this.subscriptionSummary) this.querySelector('.subscription-summary').classList.toggle('hidden', item == e.target);
            }

            if (this.subStatusContainer) {
              if (isSuscription) {
                this.subStatusContainer.innerHTML = `Every ${this.querySelector('[name="selling_plan"]:checked ~ span').innerHTML}`;
              } else {
                this.subStatusContainer.innerHTML = "{{- 'products.product.subscription.one_time_heading' | t -}}"
              }
            }
          }
        }
      }

      frequencyChangeHandler(e) {
        if (this.subStatusContainer) {
          this.subStatusContainer.innerHTML = `Every ${this.querySelector('[name="selling_plan"]:checked ~ span').innerHTML}`;
        }
      }
    }
    customElements.define('subscription-widget', SubscriptionWidget);
  });